"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'block',
        fill: theme.indigo1
    },
    fill: {
        '& > rect': {
            fill: 'currentColor'
        }
    },
    bands: {
        '& > circle:nth-child(1)': {
            fill: theme.teal2
        },
        '& > circle:nth-child(2)': {
            fill: theme.teal1
        },
        '& > circle:nth-child(3)': {
            fill: theme.indigo4
        },
        '& > circle:nth-child(4)': {
            fill: theme.indigo3
        },
        '& > circle:nth-child(5)': {
            fill: theme.indigo2
        },
        '& > circle:nth-child(6)': {
            fill: theme.indigo1
        }
    }
});
//# sourceMappingURL=logo.mark.style.js.map